import React from 'react'
import Superface from '../Superface'

export default (props) => {
    return(
        <div className="menu-item soon" style={props.style}>
            <span>{ Superface.translate(props.display) }</span>
            <span>{ Superface.translate('Prochainement') }</span>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/_MenuItemSoon.js